import { render, staticRenderFns } from "./SubCategory.vue?vue&type=template&id=015c71af&scoped=true&"
import script from "./SubCategory.vue?vue&type=script&lang=js&"
export * from "./SubCategory.vue?vue&type=script&lang=js&"
import style0 from "./SubCategory.vue?vue&type=style&index=0&id=015c71af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015c71af",
  null
  
)

export default component.exports